import React from "react";

const GreenGem = ({ className }) => {
  return (
    <svg
      id="Capa_1"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      className={className}
    >
      <g>
        <path
          d="m146.247 146.247h219.507v219.507h-219.507z"
          fill="#9fc"
          transform="matrix(.707 -.707 .707 .707 -106.039 256)"
        />
        <path d="m411.215 256-155.215-155.215v310.43z" fill="#80ecc6" />
        <g id="Gem_28_">
          <g>
            <path
              d="m512 256c0 3.9-1.5 7.8-4.501 10.499l-241 241c-2.699 3.001-6.599 4.501-10.499 4.501l-30-83.5 30-59.7 112.8-112.8 55.305-30z"
              fill="#36b3b3"
            />
            <path
              d="m256 0 30 83.5-30 59.7-112.8 112.8-69.427 30-73.773-30c0-3.9 1.5-7.8 4.501-10.499l241-241c2.699-3.001 6.599-4.501 10.499-4.501z"
              fill="#68d9c0"
            />
          </g>
        </g>
        <g fill="#4fc6b9">
          <path d="m256 368.8v143.2c-3.9 0-7.8-1.5-10.499-4.501l-241-241c-3.001-2.699-4.501-6.599-4.501-10.499h143.2z" />
          <path d="m512 256h-143.2l-112.8-112.8v-143.2c3.9 0 7.8 1.5 10.499 4.501l241 241c3.001 2.699 4.501 6.599 4.501 10.499z" />
        </g>
      </g>
    </svg>
  );
};

export default GreenGem;
